import React, { useState, useEffect, useContext } from 'react'
import { fetchFanResults, type FanResult, EventGQL } from '../../../../Api'
import { MatchupContext } from '../../../../Context'
import { Box } from '../../../../Components/Layout'
import { CHAMPIONSHIP_IDS, STATS_YEAR } from '../../../../Config/League/league.config'
import { DoughnutChartLazy } from '../../../../Components/Charts/DoughnutChartLazy'
import { getTeamColor, getTeamLocationCode, SEASON_SEGMENT_NAMES } from '../../../../Utils'
import { ProbabilitiesChartsCon, ResultsHead } from './styles'
import { ResultsBreakdown } from './ResultsBreakdown'

export const PregameProbabilitiesSection: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { eventInfo } = useContext(MatchupContext)!
  const [fanResults, setFanResults] = useState<FanResult[]>([])
  const voteText = 'Pregame Win Probabilities'

  useEffect(() => {
    if (eventInfo) {
      getVoteResults(eventInfo)
    }
  }, [eventInfo])

  const getVoteResults = async (ev: EventGQL) => {
    const yr = ev.year || STATS_YEAR
    let evId = ev.seasonSegment === 'post' ? CHAMPIONSHIP_IDS[yr] : ev.id
    let fanVotes = await fetchFanResults(evId)
    if (fanVotes && fanVotes.length > 0) {
      let sorted = fanVotes.sort((a, b) => b.count - a.count)
      setFanResults(sorted)
    }
  }

  const createDonutData = (data: FanResult[]) => {
    return data.map((d) => {
      return {
        label: getTeamLocationCode(d.teamId) ?? d.teamId,
        metric: d.count,
        color: getTeamColor(d.teamId),
      }
    })
  }

  const createDonutWinProbData = (event: EventGQL | null) => {
    if (!event || !event.pregameWinProbabilities) {
      console.log('No pregame win probabilities')
      return []
    }
    return [
      {
        label: event.homeTeam.locationCode || 'Home',
        metric: event.pregameWinProbabilities?.homeTeamWinProbability || 0,
        color: getTeamColor(event.homeTeam.officialId),
      },
      {
        label: event.awayTeam.locationCode || 'Away',
        metric: event.pregameWinProbabilities?.awayTeamWinProbability || 0,
        color: getTeamColor(event.awayTeam.officialId),
      }
    ]
  }

  return (
    <>
      {(fanResults.length > 0 || eventInfo?.pregameWinProbabilities) && (
        <Box boxColor="grey">
          <ResultsHead>{voteText}</ResultsHead>
          <ProbabilitiesChartsCon>
            {eventInfo?.pregameWinProbabilities && (
              <DoughnutChartLazy
                data={createDonutWinProbData(eventInfo)}
                title="PLL Labs"
                cutout={'70%'}
              />
            )}
            {eventInfo?.seasonSegment === SEASON_SEGMENT_NAMES.post ? (
              <ResultsBreakdown
                seasonSegment={
                  eventInfo?.seasonSegment ?? SEASON_SEGMENT_NAMES.post
                }
                fanBracketResults={fanResults}
              />
            ) : (
              <DoughnutChartLazy
                data={createDonutData(fanResults)}
                title="Fan Vote"
                cutout={'70%'}
              />
            )}
          </ProbabilitiesChartsCon>
        </Box>
      )}
    </>
  )
}
